export enum AllocationTypes {
  sales = 'SALES',
  purchases = 'PURCH',
  // Mirrors AllocationTypes.TransferRequest in the API.
  transferRequest = 'TRANSFER',
  // Manufacturing (job) yarn demand and job claims on the Stock Enquiry grids - display
  // rows; manufacturingOwner says which record the click opens. Mirrors
  // AllocationTypes.Manufacturing in the API.
  manufacturing = 'MANUFACTURING',
}
